import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState } from "react";
import { PdfPreviewModal } from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import csrPolicyPdf from "../../../../assets/tenders/resource/csr/NMDFC-CSR-Policy-Sept-2023pdf-36413685cfd5fbc35c1b2734773ece04.pdf";
import csrProgrammesPdf from "../../../../assets/tenders/resource/csr/CSRpdf-ccb7c0c4c3fe81f0ef91c404e6414b20.pdf";
import csrProgrammes202324Pdf from "../../../../assets/tenders/resource/csr/csrpdf-1da99427b694750d3848627fc8811d98.pdf";

const csrLinks = [
  {
    label: "Click here to view CSR Policy",
    title: "CSR Policy",
    fileName: "NMDFC-CSR-Policy-Sept-2023pdf-36413685cfd5fbc35c1b2734773ece04.pdf",
    href: csrPolicyPdf,
  },
  {
    label: "Click here to view details of CSR Programms",
    // meta: "Size : 497.68 KB",
    title: "Details of CSR Programms",
    fileName: "CSRpdf-ccb7c0c4c3fe81f0ef91c404e6414b20.pdf",
    href: csrProgrammesPdf,
  },
  {
    label: "Click here to view details of CSR Programms for 2023-24",
    // meta: "Size : 425.25 KB",
    title: "Details of CSR Programms for 2023-24",
    fileName: "csrpdf-1da99427b694750d3848627fc8811d98.pdf",
    href: csrProgrammes202324Pdf,
  },
];

const csrCommitteeMembers = [
  "DGM, NABARD - Chairman",
  "MD, GSMFDC (Goa) - Member",
  "MD, RMFDC (Rajasthan) - Member",
  "MD, JKSCSTBCDC (J&K) - Member",
];

const Csr = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <section className="min-w-0 flex-1 pt-1 text-[#123764]">
      <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
        Corporate Social Responsibility
      </h2>

      <p className="mb-3 text-[13px] font-semibold uppercase tracking-[0.2px]">
        Board Level Corporate Social Responsibility (CSR) Committee:
      </p>

      <ol className="mb-4 list-decimal space-y-2 pl-5 text-[13px] font-medium leading-5">
        {csrCommitteeMembers.map((member) => (
          <li key={member}>{member}</li>
        ))}
      </ol>

      <ul className="list-disc space-y-2 pl-5 text-[13px] font-medium leading-5">
        {csrLinks.map((link) => (
          <li key={link.label}>
            <button
              type="button"
              onClick={() => setSelectedDocument(link)}
              className="text-left text-[#123764] underline-offset-2 transition-colors hover:text-[#0f8a7e] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
            >
              {link.label}<FileSize href={link.href} fileName={link.fileName} />


            </button>
            {link.meta ? <span> {link.meta}</span> : null}
          </li>
        ))}
      </ul>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </section>
  );
};

export default Csr;
